module.exports = __webpack_public_path__ + "img/icon7.776f1f86.svg";